var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleCheckIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.75C11.9228 2.75 13.7673 3.51341 15.127 4.87305C16.4866 6.23269 17.25 8.07718 17.25 10C17.25 11.9228 16.4866 13.7673 15.127 15.127C13.7673 16.4866 11.9228 17.25 10 17.25C8.07718 17.25 6.23269 16.4866 4.87305 15.127C3.51341 13.7673 2.75 11.9228 2.75 10C2.75 8.07718 3.51341 6.23269 4.87305 4.87305C6.23269 3.51341 8.07718 2.75 10 2.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2101 8L9.7731 11.9996M9.77165 12L8 9.93833",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckIcon);
export default __webpack_public_path__ + "static/media/circle-check-icon.68847e78.svg";
export { ForwardRef as ReactComponent };